import { LocalDate } from "../../../shared/jsr310-localdates/types/local-date.type";
import { ValidateurEntity } from "../entities/validateur.entity";
import { RepresentantEntity } from "./representant.entity";
import { NouveauRisqueEntity } from "../entities/nouveau-risque.entity";
import { SignatairePdpEntity } from "../entities/signataire-pdp.entity";
import { ValideurSignataireEntity } from "../entities/valideur-signataire.entity";

export class StepFinalModel {

    dateInspectionCommunePrealable!: LocalDate | null;
    valideurSignataires!: ValideurSignataireEntity[];
	representants!: RepresentantEntity[];
    valideurs!: ValidateurEntity[];
    nouveauxRisques!: NouveauRisqueEntity[];
    signataires!: SignatairePdpEntity[];

}